import { ChangeOrderTemplateProps } from "./ChangePackage.interface";
import { FC } from "react";
import { Modal } from "@/components/molecules";
import { PackageList } from "@/components/pages";

const ChangeOrderTemplate : FC<ChangeOrderTemplateProps> = ({
    orderTemplates,
    isAdmin,
    loading,
    onSelectOrderTemplate,
    onClose,
}) => {
      const handleSelectedOrderTemplate = (orderTemplateId: number) => {
        const orderTemplate = orderTemplates.find((item) => item.id === orderTemplateId);
        
        if (orderTemplate)
        {
          onSelectOrderTemplate(orderTemplate);
          onClose();
        }
      }

    return (
        <Modal minWidth="600px" onClose={onClose} title="Change Package">
          <PackageList
            isAdmin={isAdmin}
            loadingOrderTemplates={loading}
            onSelectOrderTemplate={handleSelectedOrderTemplate}
            orderTemplates={orderTemplates.filter(o => !o.dea)}
            useSimpleSelect={true}
            />
        </Modal>
    );
}

export default ChangeOrderTemplate;